export const FIND_RESULT_RATING_FAILURE = 'FIND_RESULT_RATING_FAILURE';

export const findResultRatingFailure = error => ({
    type: FIND_RESULT_RATING_FAILURE,
    payload: error,
    error: true,
});
